<div class="pp">

  <!-- The product first: its panel under the menu bar (the first App Store picture's scene, cut
       out in alpha) on the stage; it opens in the lightbox with the others. -->
  <div class="pp-stage">
    <header class="pp-wrap pp-intro">
      <div class="pp-intro-main">
        <span class="pp-platform">
          <img src="./assets/third-parties/logo/macos-apps.webp" alt="">
          macOS App
        </span>
        <h1 class="pp-name">
          <!-- no app icon yet: a town stands in (see `icon`) -->
          <img [src]="icon" alt="" class="pp-icon" width="72" height="72">
          <span>Dock Town</span>
        </h1>
        <p class="pp-pitch">A cozy menu bar system monitor for your Mac: a little town whose traffic, lights and sky show how your Mac is doing, that tells you why it's slow and grows while you work</p>
        <ul class="pp-facts" aria-label="At a glance">
          <li *ngFor="let f of facts">{{ f }}</li>
        </ul>
      </div>

      <div class="pp-act">
        <div class="pp-cta">
          <a class="codigrate-button" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Install from the Mac App Store</p></a>
          <span class="codigrate-button cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
          <a class="codigrate-button cp-btn-neutral" routerLink="/themes"><p>Browse the Themes</p></a>
        </div>
      </div>
    </header>

    <div class="pp-wrap">
      <button class="pp-shot" type="button" *ngIf="heroShot as shot; else heroFigure" [class.pp-shot-wide]="hero.kind === 'wide'" (click)="openLightbox( shot )" [attr.aria-label]="'Enlarge: ' + shot.name">
        <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
      </button>
      <ng-template #heroFigure>
        <figure class="pp-shot" [class.pp-shot-wide]="hero.kind === 'wide'">
          <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
        </figure>
      </ng-template>
    </div>
  </div>

  <div class="pp-wrap">

    <!-- The stage picture's own words, under it -->
    <section class="dt-intro">
      <h2 class="dt-headline"><span class="dt-accent">{{ intro.accent }}</span> {{ intro.rest }}</h2>
      <p class="dt-text">{{ intro.description }}</p>
    </section>

    <!-- One section per thing the app does, one under the other (owner 2026-10-10: stacked, never
         side by side): the App Store picture's headline and its words, centred, and under them the
         picture's scenes as pictures of their own, each opening in the lightbox; a single scene in
         a box of one height for every section, a set of scenes (the four levels, the twelve towns,
         the four kinds of vision) as a grid. -->
    <section class="dt-feature" *ngFor="let f of pictured; trackBy: trackFeature"
             [attr.data-layout]="f.layout" [attr.data-key]="f.key" [attr.aria-labelledby]="'dt-feature-' + f.key">
      <div class="dt-feature-words">
        <h2 class="dt-headline" [id]="'dt-feature-' + f.key"><span class="dt-accent">{{ f.accent }}</span> {{ f.rest }}</h2>
        <p class="dt-text">{{ f.description }}</p>
      </div>
      <div class="dt-scenes">
        <button *ngFor="let sc of f.scenes; trackBy: trackScene" type="button" class="dt-scene" (click)="enlarge( sc )" [attr.aria-label]="'Enlarge: ' + sc.name">
          <img [src]="src( sc )" [alt]="sc.alt" [width]="sc.width" [height]="sc.height" loading="lazy" decoding="async">
          <span class="dt-scene-label" *ngIf="sc.label">{{ sc.label }}</span>
        </button>
      </div>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">What Else It Does</h2>
      <ul class="pp-list">
        <li *ngFor="let f of features">
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </li>
      </ul>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">Questions</h2>
      <div class="pp-faq">
        <details class="pp-faq-item" *ngFor="let f of faq">
          <summary>{{ f.q }}</summary>
          <p>{{ f.a }}</p>
        </details>
      </div>
    </section>

    <!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss), as on the Tidy Desktop
         page. The picture over a frosted backdrop and one pill under it: previous, the
         screenshot's name, next, close. The arrow keys page through the pictures and Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightbox.large" [alt]="lightbox.alt">
      </figure>
      <!-- the pictures on either side load while this one shows, so the arrows turn at once -->
      <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
      <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1, $event )" aria-label="Previous screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <!-- as wide as the longest name (all are stacked in one cell), so the pill keeps its size -->
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
            <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1, $event )" aria-label="Next screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <section class="cp-closing">
      <h2 class="cp-closing-title">Build Your Town</h2>
      <p class="cp-closing-text">Keep an eye on your Mac and watch a little town grow while you work</p>
      <a class="codigrate-button cp-closing-btn" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Install from the Mac App Store</p></a>
      <!-- until the listing is public: the same Coming Soon as at the top (owner 2026-10-10) -->
      <span class="codigrate-button cp-closing-btn cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
      <p class="cp-note dt-closing-note">No account, no tracking, no ads: everything stays on your Mac.
        <a class="dt-note-link" [routerLink]="URLS.plugins.macosDockTownPrivacy">Read the Dock Town Privacy Policy</a></p>
    </section>

  </div>

</div>
